<template>
    <button :class="style.iconButton" type="button" @click="$emit('click')">
        <slot></slot>
    </button>
</template>

<script>
    import Vue from 'vue'
    import style from './style.module.scss'

    export default Vue.extend({
        name: 'icon-button',
        components: {

        },
        props: {

        },
        data() {
            return {
                style: style
            }
        },
    })
</script>